angular.module('services.utility.DeepFunctionService', [])

/**
 * The DeepFunctionService provides functions for manipulating tree like
 * datastructures
 *
 * @class DeepFunctionService
 * @constructor
 * @module services.utility.DeepFunctionService
 */
.factory('DeepFunctionService', [
  function () {
    'use strict';

    /**
     * Determines if a Object meets user defined criteria.
     *
     * @callback matchCallback
     * @param {Object} node - node to check
     * @return {boolean} true for match, false for no match
     */

    /**
     * Find an item in a tree like data structure
     * NOTE: will return first value found in preorder traversal
     *
     * @param {Object} node - node that is being searched
     * @param {matchCallback} matcher - check if node matches some expectation
     * @return {Object|null} returns value if found, null otherwise
     */
    function deepFind(node, matcher) {
      var keys;
      var index;
      var result;

      // not a node
      if (typeof node !== 'object' || node === null) {
        return null;
      }

      // test current node
      if (matcher(node)) {
        return node;
      }

      // recurse for all child nodes
      keys = Object.keys(node);
      for (index = 0; index < keys.length; index += 1) {
        result = deepFind(node[keys[index]], matcher);
        if (result !== null) {
          return result;
        }
      }

      // value not found
      return null;
    }

    /**
     * Trace an item in a tree like data structure
     * NOTE: will return first value found in preorder traversal
     *
     * @param {Object} node - node that is being searched
     * @param {matchCallback} matcher - check if node matches some expectation
     * @return {Object[]|null} returns array of path to item if found, null otherwise
     */
    function deepTrace(node, matcher) {
      var keys;
      var index;
      var result;

      // not a node
      if (typeof node !== 'object' || node === null) {
        return null;
      }

      // test current node
      if (matcher(node)) {
        return [node];
      }

      // recurse for all child nodes
      keys = Object.keys(node);
      for (index = 0; index < keys.length; index += 1) {
        result = deepTrace(node[keys[index]], matcher);
        if (Array.isArray(result)) {
          result.unshift(node);
          return result;
        }
      }

      // value not found
      return null;
    }

    /**
     * Gets all nodes that match criteria.
     * NOTE: nodes will be returned in preorder
     *
     * @param {Object} node - node that is being searched
     * @param {matchCallback} matcher - check if node matches some expectation
     * @return {Object[]} returns array of nodes found
     */
    function deepFilter(node, matcher) {
      var keys;
      var index;
      var result = [];

      // not a node
      if (typeof node !== 'object' || node === null) {
        return result;
      }

      // test current node
      if (matcher(node)) {
        result.push(node);
      }

      // recurse for all child nodes
      keys = Object.keys(node);
      for (index = 0; index < keys.length; index += 1) {
        result = result.concat(deepFilter(node[keys[index]], matcher));
      }

      // return all values
      return result;
    }

    return {
      deepFind: deepFind,
      deepTrace: deepTrace,
      deepFilter: deepFilter
    };
  }
]);
